<template>
  <div
    class="artwork-notification"
    :class="[`artwork-notification--${type}`, { 'artwork-notification--steps-ui': showStepsUI }]"
  >
    <div class="artwork-notification__container">
      <div class="artwork-notification__icon">
        <UseSvg
          icon="alert-circle"
          class="artwork-notification__svg"
          :class="`artwork-notification__svg--${type}`"
        />
      </div>
      <div class="artwork-notification__message">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import UseSvg from "common/vue/components/UseSvg.vue";
import { useDtfStore } from "./store";

export default {
  name: "ArtworkNotification",
  components: { UseSvg },
  props: {
    type: {
      type: String,
      default: "warning"
    }
  },
  computed: {
    ...mapState(useDtfStore, ["showStepsUI"])
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.artwork-notification {
  margin-bottom: 10px;
  border: 1px solid $black;
  border-radius: 4px;

  &--steps-ui {
    margin-top: 16px;
    margin-bottom: 0;
  }

  &__container {
    width: 100%;
    display: flex;
    padding: 8px 14px;
    align-items: center;
  }

  &__svg {
    width: 21px;
    height: 21px;

    &--warning {
      color: $warning-yellow;
    }

    &--info {
      color: $info;
    }
  }

  &__icon {
    margin-right: 8px;
    display: flex;
  }

  &__message {
    font-size: 14px;
    color: inherit;
  }

  &--warning {
    border-color: $warning-yellow;
    color: $black;
  }

  &--info {
    border-color: $whisper;
    color: $info;
    background-color: $whisper;
  }
}
</style>
